import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React, { useEffect } from 'react'

import { BackgroundImage } from '@application/Interfaces/Atoms/BackgroundImage/BackgroundImage'
import { Image } from '@application/Interfaces/Atoms/Image'
import { Link } from '@application/Interfaces/Atoms/Link'
import { USP } from '@application/Interfaces/Features/USP'
import { HeroProfileComponentType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { sendQuoteCategoryFormShown } from '@infrastructure/AnalyticsEvent/ViewComponent'

import { LogoCarousel } from '../LogoCarousel'
// import { AgilitySection } from '../AgilitySection'
import { HeroDescription } from './HeroDescription'
import { HeroHeader } from './HeroHeader'
import { Button, ButtonsWrapper, Container, Search, Title, Wrapper } from './HeroProfile.styled'
import { HeroProfileSection } from './HeroProfileSection/HeroProfileSection'

export const HeroProfile = (props: HeroProfileComponentType): JSX.Element => {
    const {
        title,
        backgroundImage,
        mode,
        header,
        description,
        profileTitle,
        profileQuestionLabel,
        showProfileSection,
        imageLocation,
        showHelpCenterSearchForm,
        localSearch,
        MiddleContent,
        showUSPs,
        // showAgilitySection,
        usp,
        // agilitySection,
        primaryButtonLabel,
        primaryButtonLink,
        secondaryButtonLabel,
        secondaryButtonLink,
        logoSlideItems,
        showLogoCarousel,
    } = props

    const image = backgroundImage && (getImage(backgroundImage.localFile) as IGatsbyImageData)

    useEffect(() => {
        sendQuoteCategoryFormShown()
    }, [])

    const landingImagePosition = imageLocation ?? 'Background'
    const uspContent = showUSPs && usp && <USP {...usp} />
    const logoCarousel = showLogoCarousel && logoSlideItems && <LogoCarousel logos={logoSlideItems} />
    // const agilityContent = showAgilitySection && agilitySection && <AgilitySection {...agilitySection} />
    const imageOnLeftRightPosition = ['Left', 'Right'].includes(landingImagePosition) && backgroundImage

    const textColumnProps: Record<string, string | number> = {}

    if (imageOnLeftRightPosition) {
        textColumnProps[landingImagePosition === 'Right' ? 'mdUpSpacingLeft' : 'mdUpSpacingRight'] = 6
    }

    const content = (
        <>
            <Container $showProfileSection={showProfileSection}>
                <Grid
                    container
                    alignItems="center"
                    direction={landingImagePosition === 'Right' ? 'row-reverse' : 'row'}
                >
                    {imageOnLeftRightPosition && (
                        <Grid item xs={12} md={6} lg={5} textAlign="center" {...textColumnProps}>
                            <Image image={backgroundImage} loading="eager" />
                        </Grid>
                    )}
                    <Grid
                        item
                        xs={12}
                        md={showProfileSection || imageOnLeftRightPosition ? 6 : 12}
                        lg={showProfileSection || imageOnLeftRightPosition ? 7 : 12}
                        mdUpSpacingRight={showProfileSection ? 20 : 0}
                    >
                        {title && <Title>{title}</Title>}
                        <HeroHeader mode={mode} header={header} />
                        {description && <HeroDescription mode={mode} description={description} />}

                        {(primaryButtonLink || secondaryButtonLink) && (
                            <ButtonsWrapper>
                                {secondaryButtonLabel && secondaryButtonLink && (
                                    <Link to={secondaryButtonLink} className="secondary-button">
                                        <Button colorStyle="secondary">{secondaryButtonLabel}</Button>
                                    </Link>
                                )}
                                {primaryButtonLabel && primaryButtonLink && (
                                    <Link to={primaryButtonLink}>
                                        <Button>{primaryButtonLabel}</Button>
                                    </Link>
                                )}
                            </ButtonsWrapper>
                        )}
                        {MiddleContent}
                        {showHelpCenterSearchForm && localSearch && <Search localSearch={localSearch} />}
                    </Grid>
                    {showProfileSection && (
                        <Grid item xs={12} md={6} lg={5}>
                            <HeroProfileSection
                                profileTitle={profileTitle}
                                profileQuestionLabel={profileQuestionLabel}
                            />
                        </Grid>
                    )}
                </Grid>
            </Container>
            {landingImagePosition === 'Below Content' && backgroundImage && <Image image={backgroundImage} />}
        </>
    )

    if (landingImagePosition === 'Background' && image)
        return (
            <Wrapper $mode={mode}>
                <BackgroundImage image={image} title={backgroundImage.alternativeText}>
                    {content}
                </BackgroundImage>
                {uspContent}
                {logoCarousel}
            </Wrapper>
        )

    return (
        <Wrapper $mode={mode}>
            {content}
            {uspContent}
            {logoCarousel}
        </Wrapper>
    )
}
